<template>
  <div>
    <v-tabs centered dark icons-and-text>
      <v-tab :key="1">
        Blacklist
        <v-icon>block</v-icon>
      </v-tab>

      <v-tab :key="2">
        Exclude Blacklist
        <v-icon>redo</v-icon>
      </v-tab>

      <v-tab-item :key="1">
        <v-card color="red lighten-2" dark>
          <v-card-title class="headline red lighten-3">Search</v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="model"
              :items="entries"
              :loading="isLoading"
              :search-input.sync="search"
              color="white"
              hide-no-data
              hide-selected
              item-text="ip"
              item-value="API"
              label="List block ip"
              placeholder="Start typing to Search"
              prepend-icon="mdi-database-search"
              return-object
            ></v-autocomplete>
          </v-card-text>
          <v-divider></v-divider>
          <v-expand-transition>
            <v-list v-if="model" class="red lighten-3">
              <v-list-item v-for="(field, i) in fields" :key="i">
                <v-list-item-content>
                  <v-list-item-sub-title v-text="field.key"></v-list-item-sub-title>
                  <v-list-item-title v-text="field.value"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expand-transition>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-3" @click="add_ip">
              add
              <v-icon right>mdi-close-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!model" color="grey darken-3" @click="exclude_ip">
              exclude
              <v-icon right>mdi-close-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!model" color="grey darken-3" @click="model = null">
              Clear
              <v-icon right>mdi-close-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2">
        <v-layout row>
          <v-flex xs12 sm6 offset-sm3>
            <v-card>
              <v-list two-line subheader>
                <v-subheader inset>Exclude ip</v-subheader>

                <v-list-item v-for="item in ex_ip_list" :key="item.title" avatar >
                  <v-list-item-avatar>
                    <v-icon :class="[item.iconClass]">playlist_add_check</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.ip }}</v-list-item-title>
                    <v-list-item-sub-title>{{ item.description }}</v-list-item-sub-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn icon ripple @click="deleteItem(item.ip)">
                      <v-icon color="grey lighten-1">delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-divider inset></v-divider>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
export default {
  data: () => ({
    descriptionLimit: 60,
    entries: [],
    ex_ip_list: [],
    isLoading: false,
    model: null,
    search: null
  }),
  computed: {
    fields() {
      if (!this.model) return [];
      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || "n/a"
        };
      });
    }
  },
  created() {
    this.initialize();
  },
  watch: {
    search(val) {
      // Items have already been loaded
      //if (this.items.length > 0) return
      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;
      // Lazily load input items
      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }

      this.$http
        .get(this.$root.apiUrl + "/api/v1/blacklist/search/" + val)
        .then(res => {
          const { count, entries } = res.data;
          this.count = count;
          this.entries = entries;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  methods: {
    exclude_ip() {
      this.isLoading = true;
      var description = prompt(
        "Укажите причину удаления из Blacklist",
        "with blacklist"
      );
      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }
      this.$http
        .post(
          this.$root.apiUrl + "/api/v1/blacklist/addlistex",
          '{"' + this.model.ip + '" : "' + description + '"}'
        )
        .then(r => {
          if (r.status === 201) {
            this.model = null;
            this.initialize();
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },

    add_ip() {
      this.isLoading = true;
      var description = prompt(
        "Укажите причину добавления в Blacklist",
        "with blacklist"
      );
      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }
      this.$http
        .post(
          this.$root.apiUrl + "/api/v1/blacklist/addlistblk",
          '{"' + this.search + '" : "' + description + '"}'
        )
        .then(r => {
          if (r.status === 201) {
            this.model = null;
            this.initialize();
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },

    initialize() {
      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }

      this.$http
        .get(this.$root.apiUrl + "/api/v1/blacklist/exclude/")
        .then(r => {
          // console.log("r: ", JSON.stringify(r, null, 2));
          if (r.status === 200) {
            this.ex_ip_list = r.data;
          }
        });
    },
    deleteItem(item) {
      console.log(item);
      if (confirm("Are you sure you want to delete this IP?")) {
        if (localStorage.getItem("access_token") != null) {
          this.$http.defaults.headers.common[
            "X-Authorization"
          ] = localStorage.getItem("access_token");
        }
        this.$http
          .delete(this.$root.apiUrl + "/api/v1/blacklist/exclude/" + item)
          .then(r => {
            // console.log("r: ", JSON.stringify(r, null, 2));
            if (r.status === 202) {
              this.initialize();
            }
          });
      }
    }
  }
};
</script>

<codepen-resources lang="json">
  {
    "css": ["https://cdn.materialdesignicons.com/2.5.94/css/materialdesignicons.min.css"]
  }
</codepen-resources>



// WEBPACK FOOTER //
// src/pages/Blacklist.vue